

import kr from '../kr/kr';
import HTMLClass from '../kr/utils/HTMLClass';

export default class CategoryMenuScroll extends kr.Component {
    init()
    {
        this.isDown = false;
        this.startX = null;
        this.scrollLeft = null;
        this.sliderCategoryMenu = document.querySelector('.menu__visible')

        this.leftButton = document.querySelector('#scroll-left')
        this.rightButton = document.querySelector('#scroll-right')

        this.leftButton.addEventListener('click', () => {
            this.leftScroll()
        })
        
        this.rightButton.addEventListener('click', () => {
            this.rightScroll()
        })
        
        this.menuSlider();

        

        let bounce = false;
        window.addEventListener('resize', () => {
            if (bounce) {
                return;
            }
            bounce = true;
            setTimeout(() => {
                this.menuSlider();
                bounce = false;
            }, 100);
        });
    }

    menuSlider() {
        if (window.innerWidth <= 1024) {
            this.$element.addEventListener('mousedown', (e) => {
                this.isDown = true;
                this.$element.classList.add('menu__visible-active');
                this.startX = e.pageX - this.$element.offsetLeft;
                this.scrollLeft = this.$element.scrollLeft;
            });
        
            this.$element.addEventListener('mouseleave', () => {
                this.isDown = false;
                this.$element.classList.remove('menu__visible-active');
            });
        
            this.$element.addEventListener('mouseup', () => {
                this.isDown = false;
                this.$element.classList.remove('menu__visible-active');
            });
        
            this.$element.addEventListener('mousemove', (e) => {
                if(!this.isDown) return;
                e.preventDefault();
                const x = e.pageX - this.$element.offsetLeft;
                const walk = x - this.startX;
                this.$element.scrollLeft = this.scrollLeft - walk;
            });
        }
    }

    // 2 funkcje nizej

    leftScroll() {
        this.sliderCategoryMenu.scrollTo({
            left: 0,
            behavior: 'smooth'
        });
    }
    
    rightScroll() {
        this.sliderCategoryMenu.scrollTo({
            left: 10000,
            behavior: 'smooth'
        });
    }
}

kr.registerComponent('.menu__visible', {
    component: CategoryMenuScroll
});
